import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesAdministrativeService {

  private URL = environment.api;

	constructor(private http: HttpClient) { }

  saveInvoice(invoice: any) {
		return this.http.post(this.URL + "api/administrative/sale/invoices", invoice);
	}
}
